import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { ErrorHandler } from '../../common/errorHandler';
import { AuthenticationService } from '../../services/authentication.service';
import { UserService } from '../../services/user.service';
import { User } from '../../models/user.model';

@Component({
    selector: 'user-list',
    templateUrl: './user-list.component.html',
    styleUrls: ['./user-list.component.css'],
    providers: [UserService, ErrorHandler]
})
export class UserListComponent implements OnInit {
    users: Array<User>;
    isDataAvailable = false;

    constructor(
        private router: Router,
        private errorHandler: ErrorHandler,
        private userService: UserService)
    {
        this.users = new Array<User>();
    }

    ngOnInit() {
        this.getAll();
    }

    getAll(): void {
        this.userService.getUsers()
            .then(users => {
                this.users = users;
                this.isDataAvailable = true;
            })
            .catch(error => {
                this.errorHandler.do(error);
                this.isDataAvailable = true;
            });
    }

    edit(userId: string): void {
        this.router.navigate(['user/detail', userId]);
    }

    delete(userId: string): void {
        this.userService.deleteUser(userId)
            .then(response => {
                this.isDataAvailable = true;
                window.location.reload();
            })
            .catch(error => {
                this.errorHandler.do(error);
                this.isDataAvailable = true;
            });
    }


    add(): void {
        this.router.navigate(['user/detail', 0]);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/user-list/user-list.component.ts